///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { PlannerEulaDTO } from '../../../generated/shared-types.model';

export const eulaFeatureKey = 'eula';

export interface EulaState {
    isLoading: boolean;
    eula: PlannerEulaDTO;
}

export const initialState: EulaState = {
    isLoading: false,
    eula: null
};
